import { render, staticRenderFns } from "./ManagerTasksDashboard.vue?vue&type=template&id=7bd2babe&"
import script from "./ManagerTasksDashboard.vue?vue&type=script&lang=js&"
export * from "./ManagerTasksDashboard.vue?vue&type=script&lang=js&"
import style0 from "./ManagerTasksDashboard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports